






import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import CampaignCreateWizard from '@ui/Campaign/CampaignCreateWizard'

settings =
  name: 'CampaignCreate'
  components: { Back, SuperContainerView, CampaignCreateWizard }

export default VueOptions.vue settings
